var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 29.536,
    viewBox: "0 0 29.536 29.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#231f20}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.77 0C6.61 0 0 6.61 0 14.77s6.61 14.77 14.77 14.77 14.77-6.61 14.77-14.77S22.92 0 14.77 0Zm5.64 11.88v.38c0 4.57-3.7 8.27-8.27 8.28a8.21 8.21 0 0 1-4.46-1.31 5.837 5.837 0 0 0 4.3-1.21A2.92 2.92 0 0 1 9.26 16c.44.08.88.07 1.31-.05a2.902 2.902 0 0 1-2.33-2.85v-.04c.4.22.86.35 1.32.36a2.906 2.906 0 0 1-.9-3.88 8.273 8.273 0 0 0 6 3.04 2.92 2.92 0 0 1 2.18-3.5c1.01-.24 2.07.09 2.78.84.65-.13 1.28-.37 1.85-.71-.22.67-.67 1.25-1.28 1.61.58-.07 1.14-.22 1.67-.46-.39.58-.88 1.09-1.45 1.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.62 4.94H22.9v17.28H5.62z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.67 8 5.79 7.74-5.83 6.3h1.31l5.1-5.51 4.12 5.51h4.46l-6.12-8.18L21.92 8h-1.31l-4.7 5.08L12.11 8H7.65Zm1.93.97h2.05l9.05 12.11h-2.05L9.6 8.97Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconTwitter);
export default __webpack_public_path__ + "static/media/social-icon-twitter.9a5588adbf0a991c0812c1337bdfe5f0.svg";
export { ForwardRef as ReactComponent };